import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import type Message from 'owa-service/lib/contract/Message';
import { userDate, compare } from 'owa-datetime';
import { getTimeGroupHeader } from 'owa-mail-group-headers';

/**
 * Callback function to return the item headers to inject into the search results
 */
export default function getSearchResultHeaders(items: SearchResultItem[]): SearchResultItem[] {
    // mail item headers include:
    // today, yesterday, this week, last week, last month, <month + year names>
    const startDates = items.map(item =>
        userDate((item.data as Message).DateTimeReceived as string)
    );
    const sortedItems = startDates.sort((date1, date2) => compare(date1, date2));

    const headerMap = {};
    sortedItems.forEach(date => {
        const header = getTimeGroupHeader(date);
        headerMap[header.headerId] = header;
    });

    const headersToReturn: SearchResultItem[] = [];
    let previousHeaderStartTime = null;
    Object.keys(headerMap).forEach(key => {
        const headerData = headerMap[key];
        const time = previousHeaderStartTime || headerData.rangeEndTime;
        const searchResultItem = {
            type: 'mailItem',
            id: 'mailItem_header_' + time,
            immutableId: '',
            data: {
                DateTimeReceived: time,
                headerText: headerData.headerText(),
            },
            matchingTerms: [],
        } as SearchResultItem;

        previousHeaderStartTime = headerData.rangeStartTime;
        headersToReturn.push(searchResultItem);
    });

    return headersToReturn;
}
